import { render, staticRenderFns } from "./editPhone.vue?vue&type=template&id=72d2da48&scoped=true&"
import script from "./editPhone.vue?vue&type=script&lang=js&"
export * from "./editPhone.vue?vue&type=script&lang=js&"
import style0 from "./editPhone.vue?vue&type=style&index=0&id=72d2da48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2da48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('72d2da48', component.options)
    } else {
      api.reload('72d2da48', component.options)
    }
    module.hot.accept("./editPhone.vue?vue&type=template&id=72d2da48&scoped=true&", function () {
      api.rerender('72d2da48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/editPhone.vue"
export default component.exports